import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { useAppSelector } from "./hooks/storeHooks";
import { selectTheme } from "./features/dashboard/layoutSlice";
import { responsiveFontSizes, ThemeProvider } from "@mui/material/styles";
import themeCreator from "./theme/base";
import CssBaseline from "@mui/material/CssBaseline";
import StyledEngineProvider from "@mui/material/StyledEngineProvider";

function App() {
  const themeMode = useAppSelector(selectTheme);
  const theme = responsiveFontSizes(themeCreator(themeMode));

  return (
    <>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Outlet />
            <ToastContainer
              newestOnTop
              hideProgressBar
              pauseOnFocusLoss={false}
              icon={false}
              closeButton={false}
              theme={themeMode}
            />
          </LocalizationProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </>
  );
}

export default App;
